// extracted by mini-css-extract-plugin
export default {"companyContainer":"jQ-z","companyImage":"kQ-z","container":"lQ-z","heading":"mQ-z","darkText":"nQ-z","smallHeading":"oQ-z","darkBackground":"pQ-z","whiteBackground":"qQ-z"};